import { demoSubmissionListSchema, type DemoSubmission } from '@console/types'
import { apiGet } from '../api.js'

export async function fetchDemoSubmissions(): Promise<DemoSubmission[]> {
  return apiGet('/demo-submissions', demoSubmissionListSchema)
}
